import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { useIntl } from 'react-intl';
import * as motion from 'framer-motion/m';

/**
 * BannerAccordionButton.
 */
export const BannerAccordionButton = ({
  isOpen,
  btnText,
  onOpen,
}: {
  isOpen: boolean;
  btnText: string;
  onOpen: () => void;
}) => {
  const { formatMessage } = useIntl();

  return (
    <Button
      data-testid="banner-accordion-button"
      variant="transparent"
      onClick={onOpen}
      className="w-full focus:outline-white"
    >
      <Flex className="flex-[1]">
        <P className="text-white sm:text-2xl text-xl font-bold flex-[1]">
          {formatMessage({
            id: 'loggedout_quiz_relevant_content.description',
            defaultMessage: btnText,
          })}
        </P>
        <motion.div
          animate={{
            rotate: isOpen ? 180 : 0,
          }}
          className="flex-none"
        >
          <Icon icon={faChevronDown} className="text-white" />
        </motion.div>
      </Flex>
    </Button>
  );
};
